import { useState } from 'react';
import { graphql, useFragment } from 'react-relay';
import { QP_PAGE_SIZE_VALUE_DEFAULT } from '../../constants/queryParamConstants.ts';
import { type useOneBuyPageTemplateAbTestHelper_buyPage$key } from './__generated__/useOneBuyPageTemplateAbTestHelper_buyPage.graphql.ts';

const TEST_NAME = 'one_buy_page_template';

const buyPageFragment = graphql`
    fragment useOneBuyPageTemplateAbTestHelper_buyPage on ItemSearchQueryConnection {
        seoAbTestV2List {
            variant
            config {
                testName
            }
        }
        totalResults
    }
`;

type Props = {
    buyPage: useOneBuyPageTemplateAbTestHelper_buyPage$key;
};

export const useOneBuyPageTemplateAbTestHelper = ({
    buyPage: buyPageRef,
}: Props): {
    isOneBuyPageTemplateVariant: boolean;
    shouldShowRefineMenu: boolean;
} => {
    const buyPage = useFragment(buyPageFragment, buyPageRef);
    const { seoAbTestV2List, totalResults } = buyPage;
    const isOneBuyPageTemplateVariant =
        seoAbTestV2List?.find(test => test?.config?.testName === TEST_NAME)?.variant === 'VARIANT1';
    const [shouldShowRefineMenu] = useState(
        isOneBuyPageTemplateVariant && Number(totalResults) > QP_PAGE_SIZE_VALUE_DEFAULT
    );
    return { isOneBuyPageTemplateVariant, shouldShowRefineMenu };
};
